"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = void 0;
require("antd/lib/collapse/style");
var _collapse = _interopRequireDefault(require("antd/lib/collapse"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = require("../Icon");
var _lodash = require("lodash");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Panel = _collapse.default.Panel;
var Collapse = function Collapse(_ref) {
  var className = _ref.className,
    headerStyles = _ref.headerStyles,
    _ref$panels = _ref.panels,
    panels = _ref$panels === void 0 ? [] : _ref$panels,
    type = _ref.type,
    iconStyles = _ref.iconStyles,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 16 : _ref$iconSize,
    panelStyles = _ref.panelStyles,
    titleStyles = _ref.titleStyles,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? _lodash.noop : _ref$onChange;
  var defaultActiveKeys = (0, _react.useMemo)(function () {
    return panels.reduce(function (res, panel, i) {
      if (panel.defaultOpen) {
        res.push(i);
      }
      return res;
    }, []);
  }, []);
  var _useState = (0, _react.useState)(Array.from(panels, function (panel, i) {
      return defaultActiveKeys.includes(i);
    })),
    _useState2 = _slicedToArray(_useState, 2),
    panelsOpen = _useState2[0],
    setPanelsOpen = _useState2[1];
  return /*#__PURE__*/_react.default.createElement(_collapse.default, {
    className: (0, _classnames.default)(type === 'grey' ? 'bg-grey-10' : 'bg-white', className),
    bordered: false,
    onChange: function onChange(activePanelIndices) {
      setPanelsOpen(panels.map(function (p, index) {
        return activePanelIndices.includes(index.toString());
      }));
      _onChange(activePanelIndices);
    },
    defaultActiveKey: defaultActiveKeys
  }, panels.map(function (panel, index) {
    return /*#__PURE__*/_react.default.createElement(Panel, {
      className: panelStyles,
      showArrow: false,
      header: /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('tw-subtitle-sm-medium text-black w-[fit-content] flex items-center', headerStyles)
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)('mr-[6px]', titleStyles)
      }, panel.title), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
        type: panelsOpen[index] ? 'caret-up-heavy-16' : 'caret-down-heavy-16',
        size: iconSize,
        className: (0, _classnames.default)(iconStyles || '!text-black h-auto')
      })),
      id: panel.id,
      key: index
    }, panel.children);
  }));
};
exports.Collapse = Collapse;